import api from '@/api/grading-period'
import baseModule from '@/store/shared/graphql'

const STORE_TYPE = 'GRADING_PERIOD'

const API_DATA_KEY = 'gradingPeriod'

const API_DATA_BY_ID_KEY = 'id'

const defaultModule = baseModule(STORE_TYPE, API_DATA_BY_ID_KEY, API_DATA_KEY, api)

export default {
    ...defaultModule,
    namespaced: true,
}
